// banners

const elementSelector = '.nav-cat-grid__container'
const paramKey1 = 'dep'
const paramValue1 = 'mens'
const paramKey2 = 'dep'
const paramValue2 = 'womens'

function scrollToNavCatGrid(department) {
  // console.log('[scrollToNavCatGrid] Starting with department:', department)

  // Find the nav-cat-grid container
  const navCatGridContainer = document.querySelector(elementSelector)
  if (!navCatGridContainer) {
    // console.log('[scrollToNavCatGrid] Container not found')
    return
  }

  const inputValue = `mobile-nav-${department
    .toLowerCase()
    .replace(/ /g, '-')
    .replace(/[^\w-]+/g, '')}`

  // console.log('[scrollToNavCatGrid] Department:', department, '-> Input value:', inputValue)

  const selectorInput = document.querySelector(
    `nav-cat-grid-selector .nav-cat-grid__selector__item input[value="${inputValue}"]`,
  )

  if (selectorInput) {
    selectorInput.click()
  } else {
    console.error('[scrollToNavCatGrid] Err: Selector input not found')
  }

  // Scroll to the container
  setTimeout(() => {
    const headerWrapper = document.querySelector('main-nav')
    const yOffset = headerWrapper ? (headerWrapper.offsetHeight + 30) * -1 : -100
    const yCoordinate = navCatGridContainer.getBoundingClientRect().top + window.pageYOffset
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' })
  }, 100)
}

class DynamicBanner extends HTMLElement {
  constructor() {
    super()
  }

  connectedCallback() {
    this.init()
  }

  init() {
    this.setupScrollToElement()
  }

  setupScrollToElement() {
    // console.log('[DynamicBanner] setupScrollToElement')
    // Find all overlay links
    const overlayLinks = this.querySelectorAll('.banner__overlay-link')

    overlayLinks.forEach((link, i) => {
      // console.log('[DynamicBanner] link:', link)
      const urlParamKey = i == 0 ? paramKey1 : paramKey2
      const urlParamValue = i == 0 ? paramValue1 : paramValue2

      if (urlParamKey && urlParamValue) {
        link.addEventListener('click', (e) => {
          e.preventDefault()

          // If it's a department parameter, use the new simple function
          if (urlParamKey === 'dep') {
            scrollToNavCatGrid(urlParamValue)
          }

          // Track analytics
          window.igEvents = window.igEvents || []
          window.igEvents.push({ event: 'Image Banner - Scroll To Click' })
        })
      }
    })
  }
}

customElements.define('dynamic-banner', DynamicBanner)
